import React from 'react';
import { StatusBar, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { colors, spacing, radius, typography, shadow } from '../config/theme';
import { FolkStrip, StickerBackdrop, Wordmark } from './brand';

export default function WelcomeScreen({ navigation }) {
  return (
    <LinearGradient colors={[colors.gradientStart, colors.gradientEnd]} style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor={colors.gradientStart} />
      <StickerBackdrop seed="welcome" opacity={0.2} />
      <View style={styles.column}>
        <View style={styles.hero}>
          <Wordmark full height={132} color={colors.textPrimary} />
          <Text style={styles.tagline}>Смены, задачи и чек-листы — в одном месте.{'\n'}По-человечески.</Text>
          <FolkStrip color={colors.borderStrong} opacity={0.45} style={styles.rule} />
        </View>
        <TouchableOpacity style={styles.primaryButton} onPress={() => navigation.navigate('Login')} activeOpacity={0.85}>
          <Text style={styles.primaryButtonText}>Войти</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.link} onPress={() => navigation.navigate('InviteAccept')}>
          <Text style={styles.linkText}>Есть приглашение? <Text style={styles.linkAccent}>Активировать</Text></Text>
        </TouchableOpacity>
        <Text style={styles.env}>◆ TEST ◆</Text>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', paddingHorizontal: spacing.xl, overflow: 'hidden' },
  column: { width: '100%', maxWidth: 400, alignSelf: 'center' },
  hero: { marginBottom: spacing.xxl, alignItems: 'flex-start' },
  tagline: { ...typography.body, fontSize: 16, color: colors.textSecondary, marginTop: spacing.lg },
  rule: { alignSelf: 'stretch', marginTop: spacing.lg },
  primaryButton: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.md + 2,
    borderRadius: radius.md,
    alignItems: 'center',
    ...shadow.button,
  },
  primaryButtonText: { ...typography.button, color: colors.onPrimary, fontSize: 16 },
  link: { alignItems: 'center', marginTop: spacing.md },
  linkText: { ...typography.body, color: colors.textMuted },
  linkAccent: { color: colors.primary, fontWeight: '700' },
  env: { ...typography.caption, color: colors.textMuted, letterSpacing: 3, marginTop: spacing.xl, textAlign: 'center' },
});
